module.exports = __webpack_public_path__ + "static/media/bristleback.aaa39b78.png";